import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router'
import '@/styles/fonts.css'
import '@/styles/tokens.css'
import '@/styles/global.css'
import { Providers } from './providers'
import { createRouter } from './router'
import { telemetry } from './telemetry'

async function enableMocking() {
  if (import.meta.env.VITE_API_MODE !== 'mock') return
  const { startMockWorker } = await import('@/mocks/browser')
  await startMockWorker()
}

telemetry.init()

void enableMocking().then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <Providers>
        <RouterProvider router={createRouter()} />
      </Providers>
    </StrictMode>,
  )
})
